import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

const TITLES = { privacy: "Privacy Policy", terms: "Terms & Conditions", refund: "Refund Policy" };

export default function Legal({ kind }) {
  const { content } = useContent();
  const policy = content?.policies?.[kind];

  useEffect(() => {
    document.title = `${TITLES[kind]} — IPTV HUB`;
  }, [kind]);

  const chunks = (policy?.body || "").split("\n## ");

  return (
    <main className="hero-bg min-h-screen pt-[72px] pb-24">
      <div className="mx-auto max-w-3xl px-4 pt-12 sm:px-6 lg:px-8">
        <Reveal>
          <div className="mb-10 flex items-center gap-4">
            <Link to="/" data-testid="legal-back-link" className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-slate-900/10 bg-slate-900/[0.04] text-slate-600 transition-colors hover:text-electric">
              <ArrowLeft className="h-5 w-5" />
            </Link>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-electric">IPTV HUB</p>
          </div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-testid="legal-title">
            {policy?.title || TITLES[kind]}
          </h1>
          <p className="mt-3 text-xs text-slate-500">Last updated: {content?.settings?.policies_updated || "—"}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="glass mt-8 rounded-3xl p-8 sm:p-10" data-testid="legal-body">
            {policy ? (
              <div className="space-y-8">
                {chunks.map((chunk, i) => {
                  const lines = chunk.split("\n");
                  if (i === 0) {
                    return (
                      <p key={i} className="text-sm leading-relaxed text-slate-600">
                        {lines.join(" ")}
                      </p>
                    );
                  }
                  const heading = lines[0];
                  const body = lines.slice(1).join(" ");
                  return (
                    <div key={i}>
                      <h2 className="mb-3 font-display text-lg font-bold text-slate-900">{heading}</h2>
                      <p className="text-sm leading-relaxed text-slate-500">{body}</p>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-sm text-slate-500">Content coming soon.</p>
            )}
          </div>
        </Reveal>
      </div>
    </main>
  );
}
